module.exports = __webpack_public_path__ + "static/media/thub_logo.3288a603.jpg";